import { DefaultFilenameTemplateItemType, FilenameTemplateItem } from '../../..'
import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'

export abstract class FilenameTemplateItemCompatible<
  ID extends Lowercase<string> = Lowercase<string>
> extends ComplexEnumItem<ID> {
  /**
   * the default template for the instance
   *
   * @see {@link DefaultFilenameTemplateItemType}
   */
  abstract readonly defaultTemplateItems: DefaultFilenameTemplateItemType[]
  /**
   * a list of Filename Template Items compatible with the instance
   *
   * @see {@link FilenameTemplateItem}
   */
  readonly compatibleTemplateItems: FilenameTemplateItem[]
  /**
   * @see {@link ComplexEnumItem}
   */
  constructor({
    id,
    compatibleTemplateItems,
  }: Pick<
    FilenameTemplateItemCompatible<ID>,
    'compatibleTemplateItems' | 'id'
  >) {
    super(id)
    this.compatibleTemplateItems = compatibleTemplateItems
  }
}
